import useSWR, { SWRConfiguration } from 'swr';
import { DEDUP_INTERVAL_AUTOCOMPLETE } from '../../constants/swr-config';
import { customSWRPaginatedResponse, DetailedUser, PaginatedData } from '../../model/types';
import endPoints from '../../services/endpoints';
import { fetcherWithTokenWithParams } from '../../utils/fetchers';
import { localizedSearchTermForApi } from '../../utils/helpers';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useCustomerSearch(
    searchTerm: string,
    config: SWRConfiguration = {}
): customSWRPaginatedResponse<DetailedUser> {
    const isSearchActive = !!searchTerm && searchTerm.length >= 3;
    const keys = useSWRCacheKeys(isSearchActive ? endPoints.search.customers : null);

    return useSWR<PaginatedData<DetailedUser>>(
        keys ? [localizedSearchTermForApi(searchTerm), ...keys] : null,
        fetcherWithTokenWithParams,
        {
            dedupingInterval: DEDUP_INTERVAL_AUTOCOMPLETE,
            revalidateIfStale: true,
            ...config
        }
    );
}
